export default "__VITE_ASSET__N6dvoiEX__"